import { create } from 'zustand';
import { immerMiddleware } from '../services/Utils';

const userStore = () => ({
  UUID: null,
  UBUUID: null,
  UROLE: null,
  UNAME: null,
  UIMAGE: null,
  TOKEN: null
});

export const useUserStore = create(immerMiddleware(userStore));
